function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-233.49945)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect4627-3-7",
  d: "m 34.733604,254.59837 a 1.3636621,1.5796701 0 0 0 -1.363879,1.57988 v 17.94174 a 1.3636621,1.5796701 0 0 0 1.363879,1.57991 h 15.103317 a 1.3636621,1.5796701 0 0 0 1.363876,-1.57991 v -17.94174 a 1.3636621,1.5796701 0 0 0 -1.363876,-1.57988 z m 1.363877,3.15982 h 12.378076 v 14.78189 H 36.097481 Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-2",
  transform: "matrix(-0.32018578,0,0,-0.36298855,3.1012409,370.19084)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-9",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-2-6",
  transform: "matrix(0.32018578,0,0,-0.36298855,81.114848,370.34815)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-9-2",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-1-6"
})), /*#__PURE__*/React.createElement("path", {
  id: "rect2001",
  d: "m 23.453125,235.45703 a 3.2583612,3.2583612 0 0 0 -3.257813,3.25781 v 52.9668 a 3.2583612,3.2583612 0 0 0 3.257813,3.25781 h 37.154297 a 3.2583612,3.2583612 0 0 0 3.257812,-3.25781 v -52.9668 a 3.2583612,3.2583612 0 0 0 -3.257812,-3.25781 z m 3.257813,6.51563 h 30.638671 v 46.45117 H 26.710938 Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(64.882295,-54.430132)",
  id: "text943",
  "aria-label": 1
}, /*#__PURE__*/React.createElement("path", {
  id: "path945",
  d: "m -25.617791,316.47558 q 1.121819,0 1.703895,0.85724 0.592659,0.85724 0.592659,2.09547 v 1.00541 q 0,0.79374 -0.243413,1.44989 -0.232831,0.64558 -0.772574,1.07949 -0.52916,0.42333 -1.280567,0.42333 -1.121819,0 -1.714479,-0.85724 -0.582076,-0.85724 -0.582076,-2.09547 v -1.00541 q 0,-0.79374 0.232831,-1.43931 0.243413,-0.65616 0.772573,-1.07949 0.539744,-0.43391 1.291151,-0.43391 z m -1.238235,2.87863 v 1.15357 q 0,0.82549 0.338663,1.3229 0.338662,0.49741 0.899572,0.49741 0.560909,0 0.899572,-0.49741 0.338662,-0.49741 0.338662,-1.3229 v -1.15357 q 0,-0.82549 -0.338662,-1.3229 -0.338663,-0.49741 -0.899572,-0.49741 -0.56091,0 -0.899572,0.49741 -0.338663,0.49741 -0.338663,1.3229 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path947",
  d: "m -21.564442,322.6985 q 0,-0.30691 0.179915,-0.41274 0.179914,-0.11642 0.518577,-0.11642 h 1.068903 v -4.52961 l -0.867823,0.61383 q -0.158748,0.13758 -0.433911,0.13758 -0.179914,0 -0.317496,-0.11642 -0.126998,-0.11641 -0.126998,-0.30691 0,-0.16933 0.07408,-0.27516 0.07408,-0.11642 0.253997,-0.24342 l 1.428732,-0.97365 h 1.047737 v 5.69376 h 1.068903 q 0.698491,0 0.698491,0.52916 0,0.52916 -0.698491,0.52916 h -3.196126 q -0.698492,0 -0.698492,-0.52916 z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-21.1664)",
  id: "layer5"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect962",
  d: "m 0,70.351007 v 2.14041 c 0.60875411,0 1.1545872,0.309916 1.4355532,0.770486 0.280966,0.46056 0.280966,0.991521 0,1.452089 C 1.1545872,75.174554 0.60875411,75.484478 0,75.484478 v 2.140413 c 1.3290937,0 2.5743343,-0.668541 3.262292,-1.79625 0.158094,-0.259148 0.2778474,-0.534618 0.3632808,-0.818028 H 10.141372 V 72.943581 H 3.6188551 C 3.5337918,72.667773 3.416381,72.399843 3.262292,72.147256 2.5743343,71.019548 1.3290937,70.351007 0,70.351007 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rect962-1",
  d: "m 84.603357,70.396736 c -1.329094,0 -2.574332,0.668541 -3.26229,1.79625 -0.154054,0.252525 -0.271504,0.520585 -0.356564,0.796325 h -7.0801 v 2.067031 h 7.073383 c 0.08543,0.28341 0.205187,0.55888 0.363281,0.818026 0.687958,1.127711 1.933196,1.796252 3.26229,1.796252 v -2.140413 c -0.608754,0 -1.154585,-0.309926 -1.435553,-0.770486 -0.280965,-0.46057 -0.280965,-0.991529 0,-1.452089 0.280968,-0.46057 0.826799,-0.770486 1.435553,-0.770486 z"
}));

var SvgApe01 = function SvgApe01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 84.6656 63.4992",
    height: 240,
    width: 320,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApe01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ape01.4ce3f774.svg";
export { ForwardRef as ReactComponent };